module.exports = {
    NOT_FOUND: 404
}